import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { LandingComponent } from './auth/landing/landing.component';
import { LoginComponent } from './auth/login/login.component';
import { SignupComponent } from './auth/signup/signup.component';
import { AuthGuard } from './auth/auth-gaurd/auth-guard.service';
import { UnauthComponent } from './auth/unauth/unauth.component';
import { FieldUserComponent } from './auth/field-user/field-user.component';
import { GeStartedComponent } from './auth/get-started/get-started.component';
import { CustomPreloadingStrategy } from './custom-preloading-strategy';



const routes: Routes = [
  { path: 'home', component: HomeComponent,  canActivate: [AuthGuard], canActivateChild: [AuthGuard], children: [
      { path: '',redirectTo: 'people' , pathMatch: 'full'},
      { path: 'people', loadChildren: () => import('./people/people.module').then(m => m.PeopleModule) },
      { path: 'client', loadChildren: () => import('./client/client.module').then(m => m.ClientModule)},
      { path: 'report', loadChildren: () => import('./report/report.module').then(m => m.ReportModule)},
      { path: 'task', loadChildren: () => import('./task/task.module').then(m => m.TaskModule) },
      { path: 'reimburse', loadChildren: () => import('./reimbursement/reimbursement.module').then(m => m.ReimbursementModule)},
      { path: 'manage', loadChildren: () => import('./manage/manage.module').then(m => m.ManageModule) },
      { path: 'user', loadChildren: () => import('./user/user.module').then(m => m.UserModule) },
      // { path: 'attendance', loadChildren: () => import('./attendance-module/attendance.module').then(m => m.AttendanceModule)},
      // { path: 'attendance',  loadChildren: './attendance-module/attendance.module#AttendanceModule'},
      { path: 'attendance', loadChildren: () => import('./attendance-module/attendance.module.routing').then(m => m.AttendanceRoutingModule) },
      // { path: 'form', loadChildren: () => import('./form-module/form.module').then(m => m.FormModule), data: { applyPreload: true } },
      { path: 'form', loadChildren: () => import('./form-module/form.module').then(m => m.FormModule)},
      { path: 'field-user', component: FieldUserComponent}

    ]

  },
  { path: '',redirectTo: 'landing' , pathMatch: 'full'},
  { path: 'landing', component: LandingComponent},
  { path: 'login', component: LoginComponent},
  { path: 'signup', component: SignupComponent},
  { path: 'get-started', component: GeStartedComponent},
  { path: 'unauth', component: UnauthComponent, pathMatch: 'full' },
  { path: 'account', loadChildren: () => import('./account-creation/account-creation.module').then(m => m.AccountCreationModule) },
  { path: '**', redirectTo: 'landing', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: CustomPreloadingStrategy })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
